export default __webpack_public_path__ + "static/media/question_03.e95325c2.png";